import { NotificationsService } from './../../_services/notifications.service';
import { UploadService } from './../upload/service';
import { Component, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { AuthenticationService } from '../../_services/authentication.service';
import { DarkModeService } from '../../_services/dark-mode.service';
import { ToastrService } from 'ngx-toastr';
import { User } from '../../_models';
import { LogoService } from '../../_services/logo.service';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ChangeLanguageComponent } from '../change-language/change-language.component';
import { NotificationBoxComponent } from '../notification-box/notification-box.component';
import { UserBoxComponent } from '../user-box/user-box.component';
@Component({
  selector: 'app-header',
  standalone: true,
  styleUrls: ['./app-header.component.scss'],
  templateUrl: './app-header.component.html',
  imports: [CommonModule, ChangeLanguageComponent, NotificationBoxComponent, UserBoxComponent]
})
export class AppHeaderComponent implements OnInit, OnDestroy {
  @Input() public display_messages = true;
  @Input() public display_notifications = true;
  @Input() public display_tasks = true;
  @Input() public display_user = true;
  @Input() public header_components = [];
   LangM!: BsModalRef;
   user: User | undefined;
   currentUser!: User;
  data: any;
  langSelected!: any;
  uploadSubscription: any;
  numberNotification = 0;
  flag: string = '';
  flags = {
    "pt": "/assets/icon/flag/pt.svg",
    "en": "/assets/icon/flag/en.svg",
    "es": "/assets/icon/flag/es.svg"
  };
  isDark = false;
  private darkModeSub?: Subscription;
  constructor(
    public translate: TranslateService,
    private logoServ: LogoService,
    private authService: AuthenticationService,
    private notifierService: ToastrService,
    private uploadService: UploadService,
    private notificationsService: NotificationsService,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private darkModeService: DarkModeService,
  ) {
    let storelang = localStorage.getItem("lang") || 'pt';
    translate.setDefaultLang(storelang);
    translate.use(storelang);
    this.currentUser = this.authService.currentUserValue;
  }

  ngOnInit(): void {
    this.darkModeSub = this.darkModeService.getIsDark().subscribe(value => this.isDark = value);
  }

  ngOnDestroy(): void {
    this.darkModeSub?.unsubscribe();
  }

  toggleDarkMode(): void {
    this.darkModeService.toggle();
  }

  hideMl() {
    this.LangM.hide();
  }

  LangModal(Template: TemplateRef<any>) {
    this.LangM = this.modalService.show(Template, { class: 'modal-dialog ' });
  }

  // ngOnDestroy() {
  //   if(this.uploadSubscription) {
  //     this.uploadSubscription.unsubscribe();
  //   }
  // }
}
